/** `visits.status` – server-side Zoho sync state. */
export const VISIT_STATUS_PRESENTATION = {
    RECEIVED: { ar: 'مستلمة', en: 'Received', tone: 'neutral', icon: 'inbox' },
    PROCESSING: { ar: 'قيد المعالجة', en: 'Processing', tone: 'neutral', icon: 'refresh-cw' },
    SYNCED: { ar: 'تمت المزامنة', en: 'Synced', tone: 'ok', icon: 'check' },
    PARTIALLY_SYNCED: { ar: 'مزامنة جزئية', en: 'Partially synced', tone: 'partial', icon: 'circle-slash' },
    FAILED: { ar: 'فشلت', en: 'Failed', tone: 'fail', icon: 'circle-x' },
};
/** Filter values of the sync-issues list (`STUCK` is a query-only value). */
export const SYNC_ISSUE_FILTER_PRESENTATION = {
    FAILED: VISIT_STATUS_PRESENTATION.FAILED,
    PARTIALLY_SYNCED: VISIT_STATUS_PRESENTATION.PARTIALLY_SYNCED,
    STUCK: { ar: 'متوقفة أكثر من ساعة', en: 'Stuck over 1 h', tone: 'partial', icon: 'timer' },
    UNCONFIRMED_PHOTOS: { ar: 'صور غير مؤكدة على التذكرة', en: 'Photos not confirmed on ticket', tone: 'fail', icon: 'circle-alert' },
};
/** Read-back of an uploaded photo from its Zoho ticket (`attachments.verification`). */
export const ATTACHMENT_VERIFICATION_PRESENTATION = {
    VERIFIED: { ar: 'مؤكدة على التذكرة', en: 'Confirmed on ticket', tone: 'ok', icon: 'check' },
    NOT_LISTED: { ar: 'غير موجودة على التذكرة', en: 'Not on the ticket', tone: 'fail', icon: 'circle-x' },
    SIZE_MISMATCH: { ar: 'الحجم على التذكرة مختلف', en: 'Size differs on ticket', tone: 'fail', icon: 'circle-alert' },
    UNVERIFIED: { ar: 'لم يتم التحقق بعد', en: 'Not checked yet', tone: 'partial', icon: 'circle-help' },
};
/** `branches.location_status`. */
export const LOCATION_STATUS_PRESENTATION = {
    PENDING: { ar: 'بدون موقع', en: 'No location', tone: 'neutral', icon: 'map-pin' },
    SUGGESTED: { ar: 'اقتراح بانتظار المراجعة', en: 'Suggestion pending', tone: 'partial', icon: 'map-pin-plus' },
    VERIFIED: { ar: 'مؤكد', en: 'Verified', tone: 'ok', icon: 'check' },
};
/** `unverified_branch_alerts.status`. */
export const ALERT_STATUS_PRESENTATION = {
    PENDING: { ar: 'بانتظار المراجعة', en: 'Pending', tone: 'partial', icon: 'hourglass' },
    VERIFIED: { ar: 'أُضيف', en: 'Added', tone: 'ok', icon: 'check' },
    OVERRIDDEN: { ar: 'تم الربط', en: 'Linked', tone: 'neutral', icon: 'link' },
    DISMISSED: { ar: 'تم التجاهل', en: 'Dismissed', tone: 'neutral', icon: 'ban' },
};
/** Bulk import per-row outcome. */
export const IMPORT_OUTCOME_PRESENTATION = {
    CREATED: { ar: 'أُضيف', en: 'Created', tone: 'ok', icon: 'plus' },
    UPDATED: { ar: 'حُدّث', en: 'Updated', tone: 'neutral', icon: 'pencil' },
    SKIPPED: { ar: 'تُخطي', en: 'Skipped', tone: 'neutral', icon: 'minus' },
    ERROR: { ar: 'خطأ', en: 'Error', tone: 'fail', icon: 'circle-x' },
};
/** Active flag on users, brands and branches. */
export const ACTIVE_PRESENTATION = {
    ACTIVE: { ar: 'نشط', en: 'Active', tone: 'ok', icon: 'check' },
    INACTIVE: { ar: 'غير نشط', en: 'Inactive', tone: 'neutral', icon: 'circle-slash' },
};
/** Mobile offline-queue lifecycle (`QueuedVisit.state`). */
export const QUEUE_STATE_PRESENTATION = {
    PENDING: { ar: 'بانتظار الإرسال', en: 'Waiting to send', tone: 'neutral', icon: 'hourglass' },
    UPLOADING: { ar: 'جارٍ إرسال الصور', en: 'Sending photos', tone: 'neutral', icon: 'cloud-upload' },
    AWAITING_SERVER: { ar: 'تم الإرسال – جارٍ إنشاء التذكرة', en: 'Sent – creating ticket', tone: 'neutral', icon: 'refresh-cw' },
    DONE: { ar: 'تمت المزامنة', en: 'Synced', tone: 'ok', icon: 'check' },
    NEEDS_ATTENTION: { ar: 'تحتاج مراجعة', en: 'Needs attention', tone: 'fail', icon: 'circle-alert' },
};
/** `visit_assignments.status`. */
export const ASSIGNMENT_STATUS_PRESENTATION = {
    ASSIGNED: { ar: 'مُسندة', en: 'Assigned', tone: 'neutral', icon: 'inbox' },
    ACCEPTED: { ar: 'مقبولة', en: 'Accepted', tone: 'neutral', icon: 'check' },
    IN_PROGRESS: { ar: 'جارية', en: 'In progress', tone: 'now', icon: 'refresh-cw' },
    COMPLETED: { ar: 'تمت', en: 'Completed', tone: 'ok', icon: 'circle-check' },
    CANCELLED: { ar: 'ملغاة', en: 'Cancelled', tone: 'neutral', icon: 'ban' },
};
/** `visit_assignments.priority`. */
export const ASSIGNMENT_PRIORITY_PRESENTATION = {
    NORMAL: { ar: 'عادي', en: 'Normal', tone: 'neutral', icon: 'minus' },
    HIGH: { ar: 'عالي', en: 'High', tone: 'partial', icon: 'circle-alert' },
    URGENT: { ar: 'عاجل', en: 'Urgent', tone: 'fail', icon: 'circle-alert' },
};
/** Where a visit differed from its plan. */
export const DEVIATION_PRESENTATION = {
    BRANCH: { ar: 'فرع مختلف', en: 'Different branch', tone: 'partial', icon: 'store' },
    PROJECT_ADDED: { ar: 'مشروع مضاف', en: 'Project added', tone: 'neutral', icon: 'plus' },
    PROJECT_REMOVED: { ar: 'مشروع لم يُزر', en: 'Project not visited', tone: 'partial', icon: 'minus' },
    VISIT_TYPE: { ar: 'نوع زيارة مختلف', en: 'Different visit type', tone: 'partial', icon: 'circle-alert' },
    SERVICE: { ar: 'خدمة مختلفة', en: 'Different service', tone: 'partial', icon: 'circle-alert' },
};
/**
 * Anomaly level derived from the score. The split at 60 is the presentation
 * rule The Engine already used; the anomaly threshold itself stays in settings.
 */
export const ANOMALY_HIGH_SCORE = 60;
export const ANOMALY_LEVEL_PRESENTATION = {
    HIGH: { ar: 'مرتفعة', en: 'High', tone: 'fail', icon: 'shield-alert' },
    FLAGGED: { ar: 'مُعلّمة', en: 'Flagged', tone: 'partial', icon: 'shield-alert' },
};
export const anomalyLevel = (score) => (score >= ANOMALY_HIGH_SCORE ? 'HIGH' : 'FLAGGED');
/**
 * Label in the requested language; unknown tokens fall back to the raw token.
 * Language matching follows the package-wide rule (`startsWith('en')`, Arabic
 * otherwise — the product default), so `ar-EG` gets Arabic here too.
 */
export function statusLabel(table, value, language) {
    const entry = table[value];
    if (!entry)
        return value;
    return language.startsWith('en') ? entry.en : entry.ar;
}
export function statusPresentation(table, value) {
    return table[value] ?? { ar: value, en: value, tone: 'neutral', icon: 'circle-help' };
}
//# sourceMappingURL=status-presentation.js.map